export const SHOUTS = [undefined, "holdit", "objection", "takethat", "custom"];
